import { useEffect } from "react";

const DEFAULT_SUFFIX = "b+ ticket";
const DEFAULT_FALLBACK_TITLE = "b+ ticket";

interface UsePageTitleOptions {
	suffix?: string | null;
	fallback?: string;
}

export const usePageTitle = (
	title: string | null | undefined,
	options?: UsePageTitleOptions
) => {
	const suffix =
		options?.suffix === undefined ? DEFAULT_SUFFIX : options.suffix;
	const fallback =
		options?.fallback && options.fallback.trim().length > 0
			? options.fallback.trim()
			: DEFAULT_FALLBACK_TITLE;

	const resolvedTitle =
		typeof title === "string" && title.trim().length > 0
			? title.trim()
			: fallback;
	const normalizedSuffix =
		typeof suffix === "string" && suffix.trim().length > 0
			? suffix.trim()
			: null;
	const fullTitle = normalizedSuffix
		? `${resolvedTitle} | ${normalizedSuffix}`
		: resolvedTitle;

	useEffect(() => {
		document.title = fullTitle;
	}, [fullTitle]);
};

export default usePageTitle;
